import type { CreateProjectInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateProjectMutation } from '../hooks/use-project-mutations'
import { ProjectForm } from './project-form'

type ProjectCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo proyecto" dentro del side panel: el mismo ProjectForm que la edición. */
export function ProjectCreatePanel({ onDone }: ProjectCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateProjectMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateProjectInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <ProjectForm
      submitLabel="Crear proyecto"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
